import { render, staticRenderFns } from "./DescriptionWithSpellCheck.vue?vue&type=template&id=1c89d5ce&scoped=true"
import script from "./DescriptionWithSpellCheck.vue?vue&type=script&lang=js"
export * from "./DescriptionWithSpellCheck.vue?vue&type=script&lang=js"
import style0 from "./DescriptionWithSpellCheck.vue?vue&type=style&index=0&id=1c89d5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c89d5ce",
  null
  
)

export default component.exports